<template>
  <div>
    <MenuDocument/>
    <Government_receipt/>
  </div>
</template>

<script>
import MenuDocument from "@/components/admin/document_stock/menudocument/MenuDocument.vue";
import Government_receipt from "@/components/admin/document_stock/Government_receipt";
export default {
  name: "GovernmentReceipt",
  components: {
    Government_receipt,
    MenuDocument
  }
}
</script>

<style scoped>

</style>
